import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TopGamesComponent} from './top-games.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [TopGamesComponent],
  exports: [TopGamesComponent]
})
export class TopGamesModule {
}



// WEBPACK FOOTER //
// ./src/app/components/top-games/top-games.module.ts